import { render, staticRenderFns } from "./PartnerCheckbox.vue?vue&type=template&id=10cdede2&"
import script from "./PartnerCheckbox.vue?vue&type=script&lang=js&"
export * from "./PartnerCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports